import { JSGraph as OriginalJSGraph, autoPeakPicking as originalAutoPeakPicking, peakPicking as originalPeakPicking, } from 'common-spectrum';
import { convertPeak } from "./convertPeak.js";
import { getAnnotations } from "./jsgraph/getAnnotations.js";
export { AnalysesManager, Analysis, toJcamp } from 'common-spectrum';
/**
 * Picks a single peak closest to the given target wavenumber.
 * @param spectrum - The spectrum to pick from.
 * @param target - Target wavenumber value.
 * @param options - Peak picking options.
 * @returns The converted peak or undefined if no peak is found.
 */
export function peakPicking(spectrum, target, options) {
    const peak = originalPeakPicking(spectrum, target, options);
    if (!peak)
        return undefined;
    return convertPeak(peak, spectrum);
}
/**
 * Automatically picks all peaks in the spectrum.
 * @param spectrum - The spectrum to pick from.
 * @param options - Auto peak picking options.
 * @returns Array of converted peaks.
 */
export function autoPeakPicking(spectrum, options) {
    const peaks = originalAutoPeakPicking(spectrum, options);
    if (!peaks)
        return [];
    return peaks.map((peak) => convertPeak(peak, spectrum));
}
export { fromJcamp } from "./from/fromJcamp.js";
export { fromSPC } from "./from/fromSPC.js";
export const JSGraph = { ...OriginalJSGraph, getAnnotations };
//# sourceMappingURL=index.js.map